<script>
export default {
    name: 'ApiStoreChart',
    props: [
        'apiStoreItems'
    ]
}

</script>

<template>
    <div>


    <label class="labl" v-for="item in apiStoreItems">
        <input class="radioInput" style="visibility:hidden; position: absolute" type="radio" name="radioname" />
        <div  style="width: 716px; height: 100%; background: white; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
            <div  style="align-self: stretch; padding-top: 16px; padding-bottom: 16px; padding-left: 16px; padding-right: 20px; border-top-left-radius: 12px; border-top-right-radius: 12px; border: 1px #EAECF0 solid; justify-content: flex-start; align-items: center; gap: 4px; display: inline-flex">
                <div style="flex: 1 1 0; height: 28px; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
                    <div style="width: 28px; height: 28px; justify-content: center; align-items: center; display: flex">
                        <div  style="flex: 1 1 0; align-self: stretch; padding: 8px; mix-blend-mode: multiply; background: #FBFCFF; border-radius: 28px; border: 4px #F9F5FF solid; justify-content: center; align-items: center; display: inline-flex">
                            <div style="width: 16px; height: 16px; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                                <svg-component width="100%" height="100%">
                                    {!! file_get_contents(public_path('images/global/layers.svg')) !!}
                                </svg-component>
                            </div>
                        </div>
                    </div>
                    <div style="flex: 1 1 0; color: #344054; font-size: 16px; font-weight: 600; line-height: 24px; word-wrap: break-word">{{item.parcels }} Parcels -and- {{ item.tiles}} Tiles</div>
                </div>
                <div class="radio" style="width: 16px; height: 16px; position: relative; border-radius: 8px; border: 1px #D0D5DD solid" >
                    <svg-component width="85%" height="85%" style="padding-top: 2px; padding-left: 1px">
                        {!! file_get_contents(public_path('images/global/check.svg')) !!}
                    </svg-component>
                </div>
            </div>
            <div style="align-self: stretch; padding: 16px; justify-content: flex-start; align-items: flex-start; gap: 4px; display: inline-flex">
                <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: inline-flex">
                    <div style="align-self: stretch; justify-content: flex-start; align-items: flex-end; gap: 4px; display: inline-flex">
                        <div style="color: #344054; font-size: 30px; font-weight: 600; line-height: 38px; word-wrap: break-word">${{ item.price}}</div>
                        <div style="padding-bottom: 3px; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex">
                            <div style="color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">$ {{item.price/item.parcels}} / per parcel</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </label>
    </div>

</template>
